import bufet from '../resources/bufet.jpg'
import skrinky from '../resources/skrinky.jpg'

export default `
# Informace

Areál bude otevřen od 8:55. Registrace probíhá předáním nálepky(než dojdou:)...

## Wifi

SSID: **Eduroam**

SSID: **InstallFest** PASS: installf3st

SSID: **InstallFest6only** PASS: installfest6

## Sociální sítě

Používáme hashtag #InstallFest a také si můžete popovídat na
[telegramu](https://t.me/joinchat/AAAAAAxkZ-j5I_IME9OzNQ).

## Nástěnka

Prodáváte notebook? Sháníte grafickou kartu nebo kolegu? Tak prostorách bude nástěnka
kam si můžete dát A4 inzerát :)

## Oběd a jídlo
V prostorách bude oteřen bufet od cca 10:00 do 16:00.

![bufet](${bufet})

Oběd

* Sobota - vepřový řízek bramborový salát 90 Kč
* Neděle - kuřecí stehno a la bažant, rýže 90 Kč


Po celou dobu

* Po celou dobu Bagety za cca 35 Kč.
* Zákusky a další dobroty :)

Club mate

* 0,3L 30 Kč
* 0,5L 35 Kč

## Něco jiného venku?

* https://www.albert.cz/nase-prodejny/supermarket-praha-karlovo-namesti
* https://www.yelp.cz/biz/parkys-praha-4

Další restaurace v okolí

* https://www.tripadvisor.cz/RestaurantsNear-g274707-d9576025-CharlesSquare-PragueBohemia.html

## Skřínky a věšáky

Bohužel na KN:E není šatna ale je možné použít věšáky a nebo si dát věci do skřínky
(klíč od skřínky je možné získat na vrátnici v budově E za vratnou zálohu).

![skřínky](${skrinky})
`



// WEBPACK FOOTER //
// ./src/content/installfest/information/text.js